// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.copyright[data-v-4041fc9d]{\n  margin-bottom:6rem\n}\n@media (min-width: 768px){\n.copyright[data-v-4041fc9d]{\n    margin-bottom:8rem\n}\n}\n.copyright__content[data-v-4041fc9d]{\n  border-top:1px solid #f1f1f1;\n  padding-top:3.2rem\n}\n.copyright__content p[data-v-4041fc9d]{\n  color:#767676\n}\n.theme--dark .copyright__content p[data-v-4041fc9d]{\n  color:#ffffff\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
